var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaimedBonds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67511",
    "data-name": "Group 67511",
    transform: "translate(-984 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22414",
    "data-name": "Rectangle 22414",
    width: 72,
    height: 72,
    transform: "translate(984 756)",
    fill: "#ddf8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-file-invoice-dollar",
    transform: "translate(981.667 772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67445",
    "data-name": "Group 67445",
    transform: "translate(21.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67444",
    "data-name": "Group 67444",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80502",
    "data-name": "Path 80502",
    d: "M46.333,38.333A1.667,1.667,0,0,1,44.667,40h-15a8.343,8.343,0,0,1-8.333-8.333V8.333A8.343,8.343,0,0,1,29.667,0h7.525a11.6,11.6,0,0,1,8.25,3.417l5.807,5.81A11.729,11.729,0,0,1,52.495,10.7a1.667,1.667,0,0,1-2.712,1.937,8.3,8.3,0,0,0-.89-1.05l-5.808-5.81a8.352,8.352,0,0,0-1.752-1.342v7.233A1.668,1.668,0,0,0,43,13.333h5a1.667,1.667,0,1,1,0,3.333H43a5.006,5.006,0,0,1-5-5V3.372q-.4-.038-.808-.038H29.667a5.006,5.006,0,0,0-5,5V31.667a5.006,5.006,0,0,0,5,5h15A1.667,1.667,0,0,1,46.333,38.333Zm9.475-11.222-5.068-.845A1.28,1.28,0,0,1,49.667,25a1.668,1.668,0,0,1,1.667-1.667h3.78a1.678,1.678,0,0,1,1.445.833A1.667,1.667,0,1,0,59.442,22.5a5.015,5.015,0,0,0-4.33-2.5h-.447V18.332a1.667,1.667,0,1,0-3.333,0V20a5.006,5.006,0,0,0-5,5,4.6,4.6,0,0,0,3.858,4.555l5.068.845a1.28,1.28,0,0,1,1.073,1.267,1.668,1.668,0,0,1-1.667,1.667h-3.78A1.678,1.678,0,0,1,49.44,32.5a1.666,1.666,0,1,0-2.883,1.668,5.013,5.013,0,0,0,4.33,2.5h.447v1.667a1.667,1.667,0,0,0,3.333,0V36.665a5.006,5.006,0,0,0,5-5,4.6,4.6,0,0,0-3.858-4.555ZM32.167,25h9.167a1.667,1.667,0,1,0,0-3.333H32.167A4.172,4.172,0,0,0,28,25.833v3.333a4.172,4.172,0,0,0,4.167,4.167h9.167a1.667,1.667,0,1,0,0-3.333H32.167a.833.833,0,0,1-.833-.833V25.833A.833.833,0,0,1,32.167,25Zm-2.5-6.667H33A1.667,1.667,0,1,0,33,15H29.667a1.667,1.667,0,1,0,0,3.333Zm0-6.667H33a1.667,1.667,0,1,0,0-3.333H29.667a1.667,1.667,0,1,0,0,3.333Z",
    transform: "translate(-21.333)",
    fill: "#1d98b5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimedBonds);
export default __webpack_public_path__ + "static/media/claimed-bonds.2314bf235bc823b1463be3ceb63524e4.svg";
export { ForwardRef as ReactComponent };